// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"48dc7dcb","488":"2f58203a"}[chunkId] + ".chunk.js";
};